import { Routes } from "@angular/router";
import { MultiExportStartPageComponent } from "./multi-export-start-page/multi-export-start-page.component";
import { MultiExportStepsPageComponent } from "./multi-export-steps-page/multi-export-steps-page.component";
import { MultiExportTablePageComponent } from "./multi-export-table-page/multi-export-table-page.component";

export const routes: Routes = [
	{
		path: "steps",
		component: MultiExportStepsPageComponent,
		children: [
			{ path: "", redirectTo: "1", pathMatch: "full" },
			{ path: "1", component: MultiExportStartPageComponent },
			{ path: "2", component: MultiExportTablePageComponent },
		],
	},
];
